import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.3.12_next@15.5.9_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@19.1_cbad66f3c37919ccf67e10742f1eb817/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ChatButton"] */ "/vercel/path0/src/shared/chat/components/ChatButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/src/shared/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/vercel/path0/src/shared/internationalization/components/LanguageSwitcher.tsx");
